import { DrawByProductId } from '../../features/draws/types';
import { DrawStage } from '../../types/Draw';
import { ReleaseType } from '../../types/Products';

type Args = {
  /** Only the bottom bar follows the block; the desktop header keeps today's labels. */
  bottomBar: boolean;
  draw?: DrawByProductId;
  drawStage: DrawStage;
  releaseType: ReleaseType;
};

/**
 * Whether the bottom sticky CTA should offer a subscription rather than a way
 * into the draw, and which one (PTE-4262).
 *
 * Before a draw opens and after it closes there is nothing to enter, so the
 * transactional block offers "Notify me" and "Join waitlist" respectively.
 * A bar reading "Enter draw" in those states scrolls a collector down to a
 * button that is not there.
 */
export const getDrawSubscribeState = ({
  bottomBar,
  draw,
  drawStage,
  releaseType,
}: Args): 'UPCOMING' | 'SOLD_OUT' | null => {
  if (!bottomBar || !draw) return null;

  if (releaseType !== 'draw' && releaseType !== 'auction') return null;

  return drawStage === 'UPCOMING' || drawStage === 'SOLD_OUT'
    ? drawStage
    : null;
};
